import { Tag } from "../services/tags";

/**
 * Calcula se o texto sobre a cor de fundo deve ser branco ou preto.
 * Usa a fórmula relative luminance do W3C — simplificada.
 */
export function corContraste(hex: string): "white" | "black" {
  const c = hex.replace("#", "");
  if (c.length < 6) return "black";
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  // luminance perceptual
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "black" : "white";
}

export function TagChip({ tag, slug, onRemover, tamanho = "sm" }: {
  /** Quando passado, usa a tag completa (cor/ícone/nome). */
  tag?: Tag;
  /** Fallback para tags antigas que ainda não estão no catálogo — exibe só o slug. */
  slug?: string;
  onRemover?: () => void;
  tamanho?: "xs" | "sm";
}) {
  if (!tag) {
    return (
      <span className={`inline-flex items-center gap-1 rounded ${tamanho === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5"} bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300`}>
        #{slug}
      </span>
    );
  }
  const txt = corContraste(tag.cor);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded font-medium ${tamanho === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5"}`}
      style={{ background: tag.cor, color: txt === "white" ? "#fff" : "#0f172a" }}
      title={tag.nome}
    >
      <span>{tag.icone}</span>
      <span>{tag.nome}</span>
      {onRemover && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemover(); }}
          className="ml-0.5 opacity-70 hover:opacity-100"
          aria-label="Remover tag"
        >
          ×
        </button>
      )}
    </span>
  );
}
